import React from 'react';
import ViewAgentComponent from '../../../Components/Agent/ViewAgent';

export default function ViewAgent() {
    return (
        <div className='page-body'>
            <ViewAgentComponent />
        </div>
    );
}